import { gql } from "@apollo/client";

export const DELETE_MASS_UPLOAD = gql`
  mutation DeleteMassUpload($massUploadId: String!) {
    deleteMassUpload(massUploadId: $massUploadId)
  }
`;
